import { format, startOfDay, endOfDay, addMinutes } from 'date-fns';
function getEvenOddVariant(variantName, isEven, dVal) {
  const variantSuffix = isEven ? 'Even' : 'Odd';
  return `${variantName}${variantSuffix}|${variantName}${dVal ? `|${dVal}` : ''}`;
}
function getTimeList(minuteInterval = 15) {
  let start = startOfDay(new Date());
  const end = endOfDay(start);
  const timeList = [];
  while (start < end) {
    const formatted = format(start, 'hh:mma');
    timeList.push({
      name: formatted,
      value: formatted
    });
    start = addMinutes(start, minuteInterval);
  }
  return timeList;
}
export { getEvenOddVariant, getTimeList };